/**
 * Haras em que se esta trabalhando neste aparelho. A equipe cadastra varios
 * haras; o plantel, as visitas e os formularios partem do escolhido.
 */
const CHAVE = 'equiview.haras';

export function lerHarasAtual(): string | null {
  try {
    return localStorage.getItem(CHAVE);
  } catch {
    return null;
  }
}

export function gravarHarasAtual(id: string) {
  try {
    localStorage.setItem(CHAVE, id);
  } catch {
    // Sem armazenamento: vale ate recarregar.
  }
}
